
import React, { useState, useEffect, Children, useCallback } from 'react'
import { CollapsibleProps } from "./Collapsible"
import "../styles/layouts/collapsible.scss";

type Props = {
    children: any;
}

export default function CollapsibleContainer({ children }: Props) {

    const [readyChildren, setReadyChildren] = useState<any>();
    const [openId, setOpenId] = useState<number>();

    const exclusionAction = useCallback((id: number) => {
        setOpenId(id);
    }, [])

    useEffect(() => {
        const resChildren: any[] = [];
        let haveDefault = false;
        const availableChildren = children.filter((c: any) => !c.props.notAvailable);
        Children.forEach(availableChildren, (child, idx) => {
            const props: CollapsibleProps = child.props;
            if (!props.notAvailable) {//is available!
                let defaultExpanded = !haveDefault;
                haveDefault = true;
                let orderClassName = 'mid';
                if (idx === 0) {
                    orderClassName = 'top';
                } else if (idx === availableChildren.length - 1) {
                    orderClassName = 'bot';
                }
                resChildren.push(React.cloneElement(child,
                    {
                        ...child.Props,
                        className: `${child.className} ${orderClassName}`,
                        id: idx + 1,
                        key: idx,
                        exclusionAction,
                        openId,
                        defaultExpanded
                    }
                ))
            }

        })

        setReadyChildren(resChildren);

    }, [children, exclusionAction, openId])


    return <div className='collapsible-main-container'>
        {readyChildren}
    </div>


}